import type { Plano } from '../lib/precos';

/**
 * Catálogo da vitrine — espelha `apps/api/drizzle/0012_catalogo_de_planos.sql`,
 * que é o que o sistema COBRA de verdade. `planos.test.ts` costura os dois: se
 * divergirem, o teste falha antes de a landing anunciar um preço e a fatura
 * cobrar outro.
 *
 * `precoCentavos` é sempre o valor cobrado NO CICLO — o anual de Essencial
 * cobra 83880 de uma vez, nunca 6990 doze vezes.
 *
 * ## Os limites estão AQUI porque são o que diferencia um nível do outro
 * Sem eles a página teria três preços e nenhuma razão para escolher o do meio.
 * E os três números são os que o servidor de fato APLICA — sociedades em
 * `SociedadesService`, usuários em `UsuariosService`, atos/mês em
 * `AtosService`. Anunciar um teto que o sistema não impõe seria propaganda que
 * o próprio produto desmente no primeiro cliente que ultrapassar.
 */
export const PLANOS: readonly Plano[] = [
  {
    codigo: 'ESSENCIAL_MENSAL',
    nome: 'Essencial',
    periodicidade: 'MENSAL',
    precoCentavos: 9990,
    limites: { sociedades: 10, usuarios: 3, atosPorMes: 15 },
  },
  {
    codigo: 'ESSENCIAL_TRIMESTRAL',
    nome: 'Essencial',
    periodicidade: 'TRIMESTRAL',
    precoCentavos: 26970,
    limites: { sociedades: 10, usuarios: 3, atosPorMes: 15 },
  },
  {
    codigo: 'ESSENCIAL_ANUAL',
    nome: 'Essencial',
    periodicidade: 'ANUAL',
    precoCentavos: 83880,
    limites: { sociedades: 10, usuarios: 3, atosPorMes: 15 },
  },
  {
    codigo: 'PROFISSIONAL_MENSAL',
    nome: 'Profissional',
    periodicidade: 'MENSAL',
    precoCentavos: 19990,
    limites: { sociedades: 50, usuarios: 10, atosPorMes: 60 },
  },
  {
    codigo: 'PROFISSIONAL_TRIMESTRAL',
    nome: 'Profissional',
    periodicidade: 'TRIMESTRAL',
    precoCentavos: 53970,
    limites: { sociedades: 50, usuarios: 10, atosPorMes: 60 },
  },
  {
    codigo: 'PROFISSIONAL_ANUAL',
    nome: 'Profissional',
    periodicidade: 'ANUAL',
    precoCentavos: 167880,
    limites: { sociedades: 50, usuarios: 10, atosPorMes: 60 },
  },
  {
    codigo: 'ILIMITADO_MENSAL',
    nome: 'Ilimitado',
    periodicidade: 'MENSAL',
    precoCentavos: 39990,
    limites: { sociedades: null, usuarios: null, atosPorMes: null },
  },
  {
    codigo: 'ILIMITADO_TRIMESTRAL',
    nome: 'Ilimitado',
    periodicidade: 'TRIMESTRAL',
    precoCentavos: 107970,
    limites: { sociedades: null, usuarios: null, atosPorMes: null },
  },
  {
    codigo: 'ILIMITADO_ANUAL',
    nome: 'Ilimitado',
    periodicidade: 'ANUAL',
    precoCentavos: 335880,
    limites: { sociedades: null, usuarios: null, atosPorMes: null },
  },
] as const;

/** Os níveis, do menor para o maior — a ordem em que a página os mostra. */
export const NIVEIS = ['Essencial', 'Profissional', 'Ilimitado'] as const;
export type Nivel = (typeof NIVEIS)[number];

/**
 * O nível em destaque — o do MEIO, e é escolha comercial, não estética.
 *
 * Quem chega numa página de três preços ancora no mais barato; destacar o
 * intermediário move a decisão para ele. O melhor custo por mês continua sendo
 * o anual, e quem diz isso é o seletor de prazo, não o cartão.
 */
export const NIVEL_DESTAQUE: Nivel = 'Profissional';

export const DIAS_TRIAL = 7;
